App.namespace.wrap('es6.shared.tags_storage', () => {
  const ExpiringDataManager = App.es6.shared.expiring_data_manager;

  const expiringDataOptions = {
    // @see src/RoomTags/Repository/RoomTagEntitiesRepository::TAGS_KEY there is cache there as well
    storageItemName: 'tags-list-v17',
    // @todo Do not hardcode route 'room-tags.ajax.published'
    ajaxEndpoint: '/tags',
    expirationTime: 24 * 60 * 60 * 1000, // Tags are stored in Local Storage for 24 hours
  };

  /**
   * Get tags from Storage or download new ones
   *
   * @return Object with tags parameter, containing array with tags
   * { tags: Array }
   */
  const getTags = () => ExpiringDataManager(expiringDataOptions).get();

  return {
    getTags,
  };
});
